import Vue from 'vue'
import Router from 'vue-router'
import EmotesMain from '@/components/EmotesMain'
import EmoteViewer from '@/components/EmoteViewer'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Emotes',
      component: EmotesMain
    },
    {
      path: '/emote/:name',
      name: 'Emote',
      component: EmoteViewer
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js